<h2 class="title">{{'your_created_data' | translate}}</h2>

@let children = childrenSignal();
@for (child of children; track child.id) {
  <div class="container-button"
    [class.container-button-selected]="selectedChildIdSignal() === child.id">
    <button class="button-child"
      (click)="onSelectChild(child.id)">
      <div class="container-icon-name">
        <div class="container-avatar-icon">
          <img class="img-avatar" [src]="`../../../../assets/icons/${child.avatar}.svg`" alt="Avatar">
        </div>
        <h3>{{child.name}}</h3>
      </div>
    </button>

    <div class="container-icon-buttons">
      <button
        [attr.aria-label]="'edit' | translate"
        matIconButton
        (click)="editChild(child)"
        color="accent">
            <mat-icon svgIcon="Icons_EDIT" />
      </button>

      <button
        [attr.aria-label]="'edit' | translate"
        matIconButton
        (click)="showDeleteChildDialog(child)"
        color="warn">
            <mat-icon svgIcon="Icons_DELETE" />
      </button>
    </div>
  </div>
}

@if (children?.length <= 0) {
  <p class="label-no-kids-available">{{ 'no_kid_available' | translate}}</p>
}


<div class="container-button-center">
  <button matButton="filled"
    color="accent"
    class="button-rounded-center"
    (click)="goToApp()">
    {{'go_to_app' | translate}}
  </button>

  @if (children?.length === 0) {
    <button matButton="filled"
      color="accent"
      class="button-rounded-center"
      (click)="addAdditionalChild()">
      {{'add_child' | translate}}
    </button>
  }

  @if (children !== undefined && children?.length > 0) {
    <button matButton="filled"
      color="accent"
      class="button-rounded-center"
      (click)="popoverMainGoalDialog.showPopover()">
      {{'change_main_goal' | translate}}
    </button>
  }

  @if (children !== undefined && children?.length > 0) {

    @if (showAllTipsSignal()) {
      <button matButton="filled"
        color="accent"
        class="button-rounded-center"
        (click)="showTippsForChild()">
        {{'continue_with_selection' | translate}}
      </button>
    } @else {
      <button matButton="filled"
        color="accent"
        class="button-rounded-center"
        (click)="showAllTips()">
        {{'continue_without_selection' | translate}}
      </button>
    }
  }
</div>

<!-- Popover -->
<div class="container-dialog"
  #popoverDialogDelete
  popover="manual">

  <h2>{{'delete_data' | translate}}</h2>
  <p>
    {{'delete_data_text_1' | translate}}<b>{{selectedChildForDeletion()?.name}}</b>{{'delete_data_text_2' | translate}}
  </p>

  <p>
    {{'delete_data_text_3' | translate}}
  </p>

  <div class="container-button-center">

    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      (click)="cancelChildDeletion()">
      {{'cancel' | translate}}
      </button>

    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      (click)="deleteChild()">
      {{'delete' | translate}}
    </button>
  </div>
</div>

<div class="container-dialog container-dialog-main-goal"
  #popoverMainGoalDialog
  popover="auto">
  <h2>{{'goal_change_title' | translate}}</h2>

    <form>
      @for (goal of overallGoals; track $index) {
        <label>
          <input
            [defaultChecked]="selectedChild()?.goal === goal"
            type="radio"
            name="mainGoal"
            [value]="goal"
            (change)="changeCurrentMainGoal(goal)" />
          {{goal | translate}}
        </label>
      }

      <div class="container-button-center ">
        <button
          type="button"
          matButton="filled"
          class="button-rounded-center"
          color="accent"
          [disabled]="currentSelectedMainGoal() === undefined"
          (click)="submitCurrentMainGoal()">
          {{'goal_accept_title' | translate}}
        </button>
      </div>
    </form>
  </div>
